module.exports = __webpack_public_path__ + "static/media/Buttons_Video button.b6f5b733.png";